// Copyright (c) 2019 Deere & Company

import OktaState from './components/okta-state';
import actionCreators from './action-creators/index';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
    ...state.oktaState,
});

const mapDispatchToProps = (dispatch) => ({
    updateOktaIsAuthenticated: (isAuthenticated) => dispatch(
        actionCreators.updateOktaIsAuthenticated(isAuthenticated),
    ),
    updateOktaUserName: (userName) => dispatch(actionCreators.updateOktaUserName(userName)),
    updateOktaUserId: (userId) => dispatch(actionCreators.updateOktaUserId(userId)),
});

export default connect(
    mapStateToProps, mapDispatchToProps,
)(OktaState);
